export default __webpack_public_path__ + "static/media/credit-card-sync.c139096c.svg";